<template>
	<div v-if="biome" class="background" :class="biome.slug" :style="{width: width + 'px' }">

		<div v-if="biome.slug === 'winter-day' || biome.slug === 'winter-night'" class="background-content winter">
			<div class="layer sky" v-bg="'biomes/' + biome.slug + '/sky.png'"></div>
			<div class="layer dark"></div>

			<div class="layer pikes">
				<img v-for="(img, index) in pikes" :style="img.styles" :class="{ flip: img.flip }" :key="index" :src="require('@/assets/img/biomes/' + biome.slug + '/pike.png')">
			</div>
			<div class="layer mountains">
				<img v-for="(hill, index) in mountains" :class="'mountains'" :key="index" :src="require('@/assets/img/biomes/' + biome.slug + '/mountains.png')">
			</div>
			<div class="layer forests">
				<img v-for="(hill, index) in forests" :class="'forest'" :key="index" :src="require('@/assets/img/biomes/' + biome.slug + '/forest.png')">
			</div>
			<div class="layer hills">
				<img v-for="(hill, index) in hills" :class="'hill-' + hill" :key="index" :src="require('@/assets/img/biomes/' + biome.slug + '/hill-' + hill + '.png')">
			</div>

			<div class="layer ground" v-bg="'biomes/' + biome.slug + '/ground.png'"></div>
		</div>

		<div v-if="biome.slug === 'dolmen-day' || biome.slug === 'dolmen-night'" class="background-content dolmen">
			<div class="layer sky" v-bg="'biomes/' + biome.slug + '/sky.png'"></div>
			<div class="layer dark"></div>

			<div class="layer clouds">
				<img v-for="(img, index) in clouds" :style="img.styles" :class="[ 'img-' + img.n, { flip: img.flip }]" :key="index" :src="require('@/assets/img/biomes/' + biome.slug + '/cloud-' + img.n + '.png')">
			</div>
			<div class="layer hills back">
				<img v-for="(hill, index) in hills" :class="'hill-' + hill" :key="index" :src="require('@/assets/img/biomes/' + biome.slug + '/hill-' + hill + '.png')">
			</div>
			<div class="layer hills front">
				<img v-for="(hill, index) in hills" :class="'hill-' + hill" :key="index" :src="require('@/assets/img/biomes/' + biome.slug + '/hill-' + hill + '.png')">
			</div>
			<div class="layer plants">
				<img v-for="(img, index) in plants" :style="img.styles" :class="[ 'img-' + img.n, { flip: img.flip }]" :key="index" :src="require('@/assets/img/biomes/' + biome.slug + '/plant-' + img.n + '.png')">
			</div>

			<div class="layer ground" v-bg="'biomes/' + biome.slug + '/ground.png'"></div>
		</div>

		<div v-if="biome.slug === 'autumn-day' || biome.slug === 'autumn-night'" class="background-content autumn">
			<div class="layer sky" v-bg="'biomes/' + biome.slug + '/sky.png'"></div>
			<div class="layer dark"></div>

			<div class="layer clouds">
				<img v-for="(img, index) in clouds" :style="img.styles" :class="[ 'img-' + img.n, { flip: img.flip }]" :key="index" :src="require('@/assets/img/biomes/' + biome.slug + '/cloud-' + img.n + '.png')">
			</div>
			<div class="layer plain" v-bg="'biomes/' + biome.slug + '/plain.png'"></div>

			<div class="layer hills">
				<img v-for="(img, index) in hills" :style="img.styles" :class="[ 'img-' + img.n, { flip: img.flip }]" :key="index" :src="require('@/assets/img/biomes/' + biome.slug + '/hill-' + img.n + '.png')">
			</div>
			<div class="layer forests">
				<img v-for="(img, index) in forests" :style="img.styles" :class="[ 'img-' + img.n, { flip: img.flip }]" :key="index" :src="require('@/assets/img/biomes/' + biome.slug + '/forest-' + img.n + '.png')">
			</div>
			<div class="layer houses">
				<img v-for="(img, index) in houses" :style="img.styles" :class="[ 'img-' + img.n, { flip: img.flip }]" :key="index" :src="require('@/assets/img/biomes/' + biome.slug + '/house-' + img.n + '.png')">
			</div>
			<div class="layer plants">
				<img v-for="(img, index) in plants" :style="img.styles" :class="[ 'img-' + img.n, { flip: img.flip }]" :key="index" :src="require('@/assets/img/biomes/' + biome.slug + '/plant-' + img.n + '.png')">
			</div>
			<div class="layer statues">
				<img v-for="(img, index) in statues" :style="img.styles" :class="[ 'img-' + img.n, { flip: img.flip }]" :key="index" :src="require('@/assets/img/biomes/' + biome.slug + '/statue-' + img.n + '.png')">
			</div>

			<div class="layer ground" v-bg="'biomes/' + biome.slug + '/ground.png'"></div>
		</div>

		<div v-if="biome.slug === 'temple-day' || biome.slug === 'temple-night'" class="background-content temple">
			<div class="layer sky" v-bg="'biomes/' + biome.slug + '/sky.png'"></div>
			<div class="layer columns" v-bg="'biomes/' + biome.slug + '/columns.png'"></div>
			<div class="layer roof" v-bg="'biomes/' + biome.slug + '/roof.png'"></div>
			<div class="layer dark"></div>
			<div class="layer ground" v-bg="'biomes/' + biome.slug + '/ground.png'"></div>
		</div>

	</div>
</template>

<script>
import { sample, samples, random } from '@/js/utils'

export default {
	name: 'background',
	data() {
		return {
			mountains: [],
			forests: [],
			pikes: [],
			hills: [],
			houses: [],
			statues: [],
		}
	},
	props: {
		biome: { default: null },
		width: { default: 0 }
	},
	created() {
		if (this.biome.slug === 'winter-day' || this.biome.slug === 'winter-night') {
			this.pikes = [
				{ flip: sample([ true, false ]), styles: { marginLeft: random(1500, 500) + 'px ', marginRight: random(1500, 500) + 'px' } },
				{ flip: sample([ true, false ]), styles: { marginLeft: random(1500, 500) + 'px ', marginRight: random(1500, 500) + 'px' } },
				{ flip: sample([ true, false ]), styles: { marginLeft: random(1500, 500) + 'px ', marginRight: random(1500, 500) + 'px' } },
				{ flip: sample([ true, false ]), styles: { marginLeft: random(1500, 500) + 'px ', marginRight: random(1500, 500) + 'px' } },
				{ flip: sample([ true, false ]), styles: { marginLeft: random(1500, 500) + 'px ', marginRight: random(1500, 500) + 'px' } },
				{ flip: sample([ true, false ]), styles: { marginLeft: random(1500, 500) + 'px ', marginRight: random(1500, 500) + 'px' } }
			]
			this.mountains = [ 1, 1, 1, 1, 1, 1, 1 ]
			this.forests = [ 1, 1, 1, 1, 1, 1, 1 ]
			this.hills = samples([ 2, 3, 4, 5, 6 ], 4)

		}
		else if (this.biome.slug === 'dolmen-day' || this.biome.slug === 'dolmen-night') {
			this.hills = samples([ 1, 2, 3, 4 ], 4)
			this.plants = [
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { marginLeft: random(800, 200) + 'px ', marginRight: random(800, 200) + 'px' } },
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { marginLeft: random(800, 200) + 'px ', marginRight: random(800, 200) + 'px' } },
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { marginLeft: random(800, 200) + 'px ', marginRight: random(800, 200) + 'px' } },
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { marginLeft: random(800, 200) + 'px ', marginRight: random(800, 200) + 'px' } },
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { marginLeft: random(800, 200) + 'px ', marginRight: random(800, 200) + 'px' } },
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { marginLeft: random(800, 200) + 'px ', marginRight: random(800, 200) + 'px' } }
			]
			this.clouds = [
				{ n: random(3, 1), flip: sample([ true, false ]), styles: { top: random(100, -200) + 'px ', marginLeft: random(400, 200) + 'px ', marginRight: random(400, 200) + 'px' } },
				{ n: random(3, 1), flip: sample([ true, false ]), styles: { top: random(100, -200) + 'px ', marginLeft: random(400, 200) + 'px ', marginRight: random(400, 200) + 'px' } },
				{ n: random(3, 1), flip: sample([ true, false ]), styles: { top: random(100, -200) + 'px ', marginLeft: random(400, 200) + 'px ', marginRight: random(400, 200) + 'px' } },
				{ n: random(3, 1), flip: sample([ true, false ]), styles: { top: random(100, -200) + 'px ', marginLeft: random(400, 200) + 'px ', marginRight: random(400, 200) + 'px' } },
				{ n: random(3, 1), flip: sample([ true, false ]), styles: { top: random(100, -200) + 'px ', marginLeft: random(400, 200) + 'px ', marginRight: random(400, 200) + 'px' } },
				{ n: random(3, 1), flip: sample([ true, false ]), styles: { top: random(100, -200) + 'px ', marginLeft: random(400, 200) + 'px ', marginRight: random(400, 200) + 'px' } }
			]
		}
		else if (this.biome.slug === 'autumn-day' || this.biome.slug === 'autumn-night') {
			this.hills = [
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { marginLeft: random(500, 100) + 'px ', marginRight: random(500, 100) + 'px' } },
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { marginLeft: random(500, 100) + 'px ', marginRight: random(500, 100) + 'px' } },
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { marginLeft: random(500, 100) + 'px ', marginRight: random(500, 100) + 'px' } },
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { marginLeft: random(500, 100) + 'px ', marginRight: random(500, 100) + 'px' } },
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { marginLeft: random(500, 100) + 'px ', marginRight: random(500, 100) + 'px' } },
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { marginLeft: random(500, 100) + 'px ', marginRight: random(500, 100) + 'px' } }
			]
			this.plants = [
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { marginLeft: random(800, 200) + 'px ', marginRight: random(800, 200) + 'px' } },
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { marginLeft: random(800, 200) + 'px ', marginRight: random(800, 200) + 'px' } },
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { marginLeft: random(800, 200) + 'px ', marginRight: random(800, 200) + 'px' } },
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { marginLeft: random(800, 200) + 'px ', marginRight: random(800, 200) + 'px' } },
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { marginLeft: random(800, 200) + 'px ', marginRight: random(800, 200) + 'px' } },
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { marginLeft: random(800, 200) + 'px ', marginRight: random(800, 200) + 'px' } }
			]
			this.forests = [
				{ n: 1, flip: sample([ true, false ]), styles: { marginLeft: random(800, 200) + 'px ', marginRight: random(800, 200) + 'px' } },
				{ n: 1, flip: sample([ true, false ]), styles: { marginLeft: random(800, 200) + 'px ', marginRight: random(800, 200) + 'px' } },
				{ n: 1, flip: sample([ true, false ]), styles: { marginLeft: random(800, 200) + 'px ', marginRight: random(800, 200) + 'px' } },
				{ n: 1, flip: sample([ true, false ]), styles: { marginLeft: random(800, 200) + 'px ', marginRight: random(800, 200) + 'px' } },
				{ n: 1, flip: sample([ true, false ]), styles: { marginLeft: random(800, 200) + 'px ', marginRight: random(800, 200) + 'px' } },
				{ n: 1, flip: sample([ true, false ]), styles: { marginLeft: random(800, 200) + 'px ', marginRight: random(800, 200) + 'px' } }
			]
			this.houses = [
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { marginLeft: random(1200, 400) + 'px ', marginRight: random(1200, 400) + 'px' } },
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { marginLeft: random(1200, 400) + 'px ', marginRight: random(1200, 400) + 'px' } },
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { marginLeft: random(1200, 400) + 'px ', marginRight: random(1200, 400) + 'px' } },
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { marginLeft: random(1200, 400) + 'px ', marginRight: random(1200, 400) + 'px' } },
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { marginLeft: random(1200, 400) + 'px ', marginRight: random(1200, 400) + 'px' } },
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { marginLeft: random(1200, 400) + 'px ', marginRight: random(1200, 400) + 'px' } }
			]
			this.clouds = [
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { top: random(100, -200) + 'px ', marginLeft: random(400, 50) + 'px ', marginRight: random(400, 50) + 'px' } },
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { top: random(100, -200) + 'px ', marginLeft: random(400, 50) + 'px ', marginRight: random(400, 50) + 'px' } },
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { top: random(100, -200) + 'px ', marginLeft: random(400, 50) + 'px ', marginRight: random(400, 50) + 'px' } },
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { top: random(100, -200) + 'px ', marginLeft: random(400, 50) + 'px ', marginRight: random(400, 50) + 'px' } },
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { top: random(100, -200) + 'px ', marginLeft: random(400, 50) + 'px ', marginRight: random(400, 50) + 'px' } },
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { top: random(100, -200) + 'px ', marginLeft: random(400, 50) + 'px ', marginRight: random(400, 50) + 'px' } }
			]
			this.statues = [
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { marginLeft: random(400, 200) + 'px ', marginRight: random(400, 200) + 'px' } },
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { marginLeft: random(400, 200) + 'px ', marginRight: random(400, 200) + 'px' } },
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { marginLeft: random(400, 200) + 'px ', marginRight: random(400, 200) + 'px' } },
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { marginLeft: random(400, 200) + 'px ', marginRight: random(400, 200) + 'px' } },
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { marginLeft: random(400, 200) + 'px ', marginRight: random(400, 200) + 'px' } },
				{ n: random(2, 1), flip: sample([ true, false ]), styles: { marginLeft: random(400, 200) + 'px ', marginRight: random(400, 200) + 'px' } }
			]
		}
	}
}
</script>

<style lang="stylus" scoped>
	
.background
	absolute -8px
	from = 348px
	
	&.winter-day .background-content .layer.dark
		background-color #363850
	&.winter-night .background-content .layer.dark
		background-color #291b3e
	&.dolmen-day .background-content .layer.dark
		background-color #1e2430
	&.dolmen-night .background-content .layer.dark
		background-color #081226
	&.autumn-day .background-content .layer.dark
		background-color #371a28
	&.autumn-night .background-content .layer.dark
		background-color #0D0825
	&.temple-day .background-content .layer.dark
		background-color #211d13

	.background-content

		&.winter
			absolute 0
			.layer
				absolute 0
				background left bottom repeat-x
				background-size auto 100%
				&.dark
					top auto
					height (from + 50px)
				&.pikes
					flex flex-end flex-start row
					bottom (from + 200px)
					transform translateX(-400px)
					img
						width (521px / 1)
						height (407px / 1)
						&.flip
							transform scaleX(-1)
				&.mountains
					flex flex-end flex-start row
					bottom (from + 85px)
					img
						width (1919px / 1.25)
						height (478px / 1.25)
				&.forests
					flex flex-end flex-start row
					bottom (from + 55px)
					img
						width (936px / 1.25)
						height (284px / 1.25)
				&.hills
					flex flex-end flex-start row
					bottom (from + 72px)
					img
						width (1920px / 1.25)
						height (582px / 1.25)
				&.clouds
					flex flex-end flex-start row
					bottom (from + 472px)
					img
						height 0
						margin 0 200px
						&.flip
							transform scaleX(-1)
						&.img-1
							height round(72px / 1.7)
						&.img-2
							height round(76px / 1.7)
						&.img-3
							height round(117px / 1.7)
				&.ground
					background-size auto 131px
					bottom from
					

		&.dolmen
			absolute 0
			.layer
				absolute 0
				background left bottom repeat-x
				background-size auto 100%
				&.dark
					top auto
					height (from + 50px)
				&.hills
					flex flex-end flex-start row
					bottom (from + 72px)
					&.back
						// bottom (from - 0px)
						transform scale(1) translateX(-200px)
						flex-direction row-reverse
					&.front
						opacity 1
						transform translateX(-200px)
					img
						height 0
						&.hill-1
							height round(812px / 1.7)
						&.hill-2
							height round(784px / 1.7)
						&.hill-3
							height round(658px / 1.7)
						&.hill-4
							height round(176px / 1.7)
				&.plants
					flex flex-end flex-start row
					bottom (from + 72px)
					img
						height 0
						margin 0 200px
						&.flip
							transform scaleX(-1)
						&.img-1
							height round(880px / 1.7)
						&.img-2
							height round(859px / 1.7)
						&.img-3
							height round(880px / 1.7)
				&.clouds
					flex flex-end flex-start row
					bottom (from + 472px)
					img
						height 0
						margin 0 200px
						&.flip
							transform scaleX(-1)
						&.img-1
							height round(72px / 1.7)
						&.img-2
							height round(76px / 1.7)
						&.img-3
							height round(117px / 1.7)
				&.ground
					background-size auto 131px
					bottom from
					

		&.autumn
			absolute 0
			from = 330px
			.layer
				absolute 0
				background left bottom repeat-x
				background-size auto 100%
				&.dark
					top auto
					height (from + 50px)
				&.hills
					flex flex-end flex-start row
					bottom (from + 180px)
					img
						height 0
						&.flip
							transform scaleX(-1)
						&.img-1
							height round(160px / 1.5)
						&.img-2
							height round(223px / 1.5)
				&.plants
					flex flex-end flex-start row
					bottom (from + 72px)
					transform scale(1) translateX(-300px)
					img
						height 0
						margin 0 200px
						&.flip
							transform scaleX(-1)
						&.img-1
							height round(652px / 1.3)
						&.img-2
							height round(650px / 1.3)
				&.forests
					flex flex-end flex-start row
					bottom (from + 110px)
					transform scale(1) translateX(-500px)
					img
						height 0
						margin 0 200px
						&.flip
							transform scaleX(-1)
						&.img-1
							height round(460px / 1.3)
				&.statues
					flex flex-end flex-start row
					bottom (from + 110px)
					img
						height 0
						margin 0 200px
						&.flip
							transform scaleX(-1)
						&.img-1
							height round(144px / 1.7)
						&.img-2
							height round(352px / 1.7)
				&.houses
					flex flex-end flex-start row
					bottom (from + 95px)
					transform scale(1) translateX(-250px)
					img
						height 0
						margin 0 200px
						&.flip
							transform scaleX(-1)
						&.img-1
							height round(418px / 1.3)
						&.img-2
							height round(397px / 1.3)
				&.clouds
					flex flex-end flex-start row
					bottom (from + 500px)
					img
						height 0
						margin 0 200px
						&.flip
							transform scaleX(-1)
						&.img-1
							height round(90px / 1)
						&.img-2
							height round(64px / 1)
				&.ground
					background-size auto 285px
					bottom from
				&.plain
					background-size auto 120px
					bottom (from + 100px)


		&.temple
			absolute 0
			from = 330px
			.layer
				absolute 0
				background left bottom repeat-x
				background-size auto 100%
				&.dark
					top auto
					height (from + 50px)
				&.ground
					background-size auto 183px
					bottom from
				&.columns
					background-size auto 539px
					bottom (from + 128px)
				&.roof
					background-size auto 66px
					bottom (from + 637px)


		

.background.autumn-night .background-content.autumn .layer.statues img.img-1
	height round(218px / 1.7)
</style>
